// extracted by mini-css-extract-plugin
export default {"textbook-container":"Textbook_textbook-container__8vP9P","tab-container":"Textbook_tab-container__LMntv"};